import AVAILABLE_INCENTIVES from './incentives';

const currentYear = new Date().getFullYear();
export const RECOMMENDATION_FILTERS = [
  {
    icon: 'sun',
    label: 'Solar Recommendation',
    name: 'recommendations.pv',
    min: 0,
    max: 3
  },
  {
    icon: 'bulb',
    label: 'CHP Recommendation',
    name: 'recommendations.chp',
    min: 0,
    max: 3
  },
  {
    icon: 'battery',
    label: 'Battery Storage Recommendation',
    name: 'recommendations.storage',
    min: 0,
    max: 3
  },
  {
    icon: 'hydrogen',
    label: 'Fuel Cell Recommendation',
    name: 'recommendations.fuel_cell',
    min: 0,
    max: 3
  }
];

export const POPULAR_RANGE_FILTERS = {
  popular: [
    {
      name: 'estimates_int.solar',
      label: 'Solar Estimates',
      start: 0,
      end: 100,
      states: ['ny', 'ma', 'tx', 'nj', 'ct', 'palau', 'japan', '*'],
      category: null
    },
    {
      name: 'estimates_int.chp',
      label: 'CHP Estimates',
      start: 0,
      end: 100,
      states: ['ny', 'ma', 'tx', 'nj', 'ct', 'palau', 'japan', '*'],
      category: null
    },
    {
      name: 'estimates_int.storage',
      label: 'Battery Storage Estimates',
      start: 0,
      end: 100,
      states: ['ny', 'ma', 'tx', 'nj', 'ct', 'palau', 'japan', '*'],
      category: null
    },
    {
      name: 'estimates_int.fuel_cell',
      label: 'Fuel Cell Estimates',
      start: 0,
      end: 100,
      states: ['ny', 'ma', 'tx', 'nj', 'ct', 'palau', 'japan', '*'],
      category: null
    },
    {
      name: 'der_score',
      label: 'DER Adoption Potential',
      start: 0,
      end: 100,
      states: ['ny', 'ma', 'tx', 'nj', 'ct', 'palau', 'japan', '*'],
      category: null
    }
  ],
  adv_popular: []
};

export const RANGE_FILTERS = {
  'Financial Estimates': [
    {
      name: 'financial_total_gross_project_cost',
      label: 'Total Gross Project Cost',
      start: 0,
      end: 100000000,
      step: 1000,
      states: ['ny'],
      category: 'financial'
    },
    {
      name: 'financial_irr',
      label: 'IRR',
      start: 0,
      end: 1,
      step: 0.01,
      states: ['ny'],
      category: 'financial'
    },
    {
      name: 'financial_payback_period',
      label: 'Payback Period',
      start: 0,
      end: 10,
      step: 0.1,
      states: ['ny'],
      category: 'financial'
    },
    {
      name: 'financial_net_present_value',
      label: 'Net Present Value',
      start: 0,
      end: 10000000,
      step: 1000,
      states: ['ny'],
      category: 'financial'
    },
    {
      name: 'financial_ppa_1st_year_savings_to_customer',
      label: '1st Year Savings',
      start: 0,
      end: 1000000,
      step: 1000,
      states: ['ny'],
      category: 'financial'
    },
    {
      name: 'financial_ppa_kwh_rate',
      label: 'PPA kWh Rate',
      start: 0,
      end: 0.5,
      step: 0.01,
      states: ['ny'],
      category: 'financial'
    }
  ],
  Energy: [
    {
      name: 'ghg_emission_total',
      label: 'GHG Emissions',
      start: 0,
      end: 1000000,
      states: ['ny'],
      category: 'energy'
    },

    {
      name: 'energy_star_score',
      label: 'Energy Star Rating',
      start: 0,
      end: 100,
      states: ['ny'],
      category: 'energy'
    },

    {
      name: 'eui',
      label: 'Energy Use Intensity',
      start: 0,
      end: 1000000,
      states: ['ny'],
      category: 'energy'
    }
  ],
  'Building profile': [
    {
      name: 'building_far',
      label: 'Floor Area Ratio',
      start: 0,
      end: 200,
      states: ['ny']
    },

    {
      name: 'last_renovation',
      label: 'Last Renovation',
      start: 1700,
      end: currentYear,
      states: ['ny']
    },
    {
      name: 'residential_units',
      label: 'Residential Units',
      start: 0,
      end: 300,
      states: ['ny']
    }
  ]
};

export const BOROUGH_TYPES = [
  {
    value: 1,
    label: 'Manhattan',
    acronym: 'mn'
  },
  {
    value: 3,
    label: 'Brooklyn',
    acronym: 'bk'
  },
  {
    value: 4,
    label: 'Queens',
    acronym: 'qu'
  },
  {
    value: 2,
    label: 'The Bronx',
    acronym: 'bx'
  },
  {
    value: 5,
    label: 'Staten Island',
    acronym: 'si'
  }
];

export const STATES = [
  {
    value: 'New York',
    label: 'New York',
    acronym: 'ny'
  },
  {
    value: 'Connecticut',
    label: 'Connecticut',
    acronym: 'ct'
  },
  {
    value: 'Massachusetts',
    label: 'Massachusetts',
    acronym: 'ma'
  },
  {
    value: 'New Jersey',
    label: 'New Jersey',
    acronym: 'nj'
  },
  {
    value: 'Texas',
    label: 'Texas',
    acronym: 'tx'
  },
  {
    value: 'Palau',
    label: 'Palau',
    acronym: 'palau'
  },
  {
    value: 'Japan',
    label: 'Japan',
    acronym: 'japan'
  }
];

export const PROPERTY_TYPES = [
  {
    value: 'A',
    label: 'One Family Dwelling'
  },
  {
    value: 'B',
    label: 'Two Family Dwelling'
  },
  {
    value: 'C',
    label: 'Walk Up Apartment'
  },
  {
    value: 'D',
    label: 'Elevator Apartment'
  },
  {
    value: 'E',
    label: 'Warehouse'
  },
  {
    value: 'F',
    label: 'Factory/Industrial Building'
  },
  {
    value: 'G',
    label: 'Garage or Gasoline Station'
  },
  {
    value: 'H',
    label: 'Hotel'
  },
  {
    value: 'I',
    label: 'Healthcare'
  },
  {
    value: 'J',
    label: 'Theatre'
  },
  {
    value: 'K',
    label: 'Retail'
  },
  {
    value: 'L',
    label: 'Loft Building'
  },
  {
    value: 'M',
    label: 'Religious Building'
  },
  {
    value: 'N',
    label: 'Asylum/Home'
  },
  {
    value: 'O',
    label: 'Office Building'
  },
  {
    value: 'P',
    label: 'Public Assembly Place'
  },
  {
    value: 'Q',
    label: 'Outdoor Recreation Facility'
  },
  {
    value: 'R',
    label: 'Condomonium'
  },
  {
    value: 'S',
    label: 'Mix-Use Residence'
  },
  {
    value: 'T',
    label: 'Transportation Facility'
  },
  {
    value: 'U',
    label: 'Utility'
  },
  {
    value: 'V',
    label: 'Vacant Land'
  },
  {
    value: 'W',
    label: 'Education'
  },
  {
    value: 'Y',
    label: 'Government Building'
  },
  {
    value: 'Z',
    label: 'Miscellaneous'
  }
].sort((a, b) =>
  a.label.toLowerCase().localeCompare(b.label, 'en', { sensitivity: 'base' })
);
export const INCENTIVES = AVAILABLE_INCENTIVES;

export const BUILDING_CLASSES = [
  {
    label: 'Power Station',
    value: 'power_station'
  },
  {
    label: 'Miscellaneous',
    value: 'miscellaneous'
  },
  {
    label: 'Arts Center',
    value: 'art_center'
  },
  {
    label: 'Bank',
    value: 'bank'
  },
  {
    label: 'Restaurant',
    value: 'bar'
  },
  {
    label: 'Bus Station',
    value: 'bus_station'
  },
  {
    label: 'Cafe',
    value: 'cafe'
  },
  {
    label: 'Car Service',
    value: 'car_parts'
  },
  {
    label: 'Car Rental',
    value: 'car_rental'
  },
  {
    label: 'Car Wash',
    value: 'car_wash'
  },
  {
    label: 'Casino',
    value: 'casino'
  },
  {
    label: 'Childcare Facility',
    value: 'childcare'
  },
  {
    label: 'Religious Building',
    value: 'church'
  },
  {
    label: 'Cinema',
    value: 'cinema'
  },
  {
    label: 'Clinic',
    value: 'clinic'
  },
  {
    label: 'Higher Education',
    value: 'college'
  },
  {
    label: 'Community Center',
    value: 'community_center'
  },
  {
    label: 'Courthouse',
    value: 'courthouse'
  },
  {
    label: 'Healthcare Facility',
    value: 'doctors'
  },
  {
    label: 'Embassy',
    value: 'embassy'
  },
  {
    label: 'Fast Food',
    value: 'fast_food'
  },
  {
    label: 'Ferry Terminal',
    value: 'ferry_terminal'
  },
  {
    label: 'Fire Station',
    value: 'fire_station'
  },
  {
    label: 'Fuel Station',
    value: 'fuel'
  },
  {
    label: 'Healthcare',
    value: 'healthcare'
  },
  {
    label: 'Hospital',
    value: 'hospital'
  },
  {
    label: 'Library',
    value: 'library'
  },
  {
    label: 'Marketplace',
    value: 'marketplace'
  },
  {
    label: 'Nursing Home',
    value: 'nursing_home'
  },
  {
    label: 'Parking Facility',
    value: 'parking'
  },
  {
    label: 'Pharmacy',
    value: 'pharmacy'
  },
  {
    label: 'Police Station',
    value: 'police'
  },
  {
    label: 'Post Office',
    value: 'post_office'
  },
  {
    label: 'Prison',
    value: 'prison'
  },
  {
    label: 'Bar',
    value: 'pub'
  },
  {
    label: 'Public Building',
    value: 'public_building'
  },
  {
    label: 'Ranger Station',
    value: 'ranger_station'
  },
  {
    label: 'Recycling Facility',
    value: 'recycling'
  },
  {
    label: 'School',
    value: 'school'
  },
  {
    label: 'Shelter',
    value: 'shelter'
  },
  {
    label: 'Social Facility',
    value: 'social_centre'
  },
  {
    label: 'Studio',
    value: 'studio'
  },
  {
    label: 'Swimming Pool',
    value: 'swimming_pool'
  },
  {
    label: 'Theater',
    value: 'theatre'
  },
  {
    label: 'Restroom Facility',
    value: 'toilets'
  },
  {
    label: 'Town Hall',
    value: 'town_hall'
  },
  {
    label: 'Veterinary Facility',
    value: 'veterinary'
  }
];

export const PROPERTY_SUMMARY_FILTERS = [
  {
    name: 'floor_area_total',
    label: 'Total Square Feet',
    start: 0,
    end: 5000000,
    states: ['ny'],
    category: 'building_area'
  },
  {
    name: 'number_of_buildings',
    label: 'Number Of Buildings',
    start: 0,
    end: 10,
    states: ['ny']
  },
  {
    name: 'floors',
    label: 'Number of Floors',
    start: 0,
    end: 100,
    states: ['ny', 'japan'],
    category: null
  },
  {
    name: 'year_built',
    label: 'Year Built',
    start: 1900,
    end: currentYear,
    states: ['ny'],
    category: null
  }
];
